<template>
  <div
    class="inner-scroll"
    :class="{ 'has-footer': hasFooter, 'fancy-scroll': hasFooter }"
    @scroll.passive="onDatabaseLinkedViewScroll"
  >
    <div class="content flow-items-modal-scroll">
      <div class="tab tab-form">
        <div
          ref="formContainer"
          class="form-container"
          :class="{ 'create-custom-db-wrapper': isCreateCustomDB }"
        >
          <div
            class="field-search-wrapper"
            v-if="!isAddingNewItem && elements.length"
            :class="{ 'create-custom-db': isCreateCustomDB }"
          >
            <input
              type="text"
              placeholder="Suche"
              class="search-text"
              v-model="elementSearch"
              :disabled="isPropsModalVisible"
            />
            <img src="@/assets/img/search-icon.svg" class="search-icon" />
            <CommonSwitch
              v-b-tooltip.hover
              v-if="isCreateCustomDB && !isEditMode && !isCalledInElementsProps"
              title="Aktivieren Sie die Paginierung"
              class="pagination-switch"
              v-model="databaseMeta.pagination"
            ></CommonSwitch>
          </div>
          <form
            class="codelos-app"
            ref="customdbFrom"
            :id="getId('codelosForm')"
            :class="{
              'full-width': isFullWidthForm,
              'ai-cursor-active': isAskAiUiModalVisible,
            }"
            @submit.prevent="validateInputs"
            @click="onClickForm"
          >
            <div
              v-for="(tab, tabIdx) in mutableStructure.tabs"
              :key="tab.id"
              class="form-tab fancy-scroll"
              ref="formBuilderElementWraper"
              @scroll.passive="showScrollbar"
            >
              <div v-for="(row, rowIdx) in tab.rows" :key="rowIdx" class="row">
                <div
                  v-for="(col, colIdx) in row.cols"
                  :key="colIdx"
                  class="col"
                  :class="{
                    showResultInForm:
                      colIdx !== 0 && colIdx === row.cols.length - 1,
                  }"
                >
                  <template
                    v-if="!(colIdx !== 0 && colIdx === row.cols.length - 1)"
                  >
                    <div
                      v-for="(element, idx) in getMutableElements"
                      v-show="showElements(element)"
                      :key="idx"
                      :id="getId(idx)"
                      :class="{
                        large: isLargeWrapperRequired(element.type),
                      }"
                    >
                      <ElementRenderer
                        :flowRunnerEndpoint="flowRunnerEndpoint"
                        :isAskAiUiModalVisible="isAskAiUiModalVisible"
                        class="form-elements"
                        :ref="`formElements${element.id}`"
                        :element="element"
                        :elements="getMutableElements"
                        :colIdx="colIdx"
                        :tabIdx="tabIdx"
                        :rowIdx="rowIdx"
                        :idx="idx"
                        :elementCount="mutableElements.length"
                        :isLargeWrapperRequired="isLargeWrapperRequired"
                        :isUserHasAccess="isUserHasAccess"
                        :isEditable="isEditable"
                        :activeDropZone="activeDropZone"
                        :isContentEditable="isContentEditable"
                        :isEmptyFileInput="isEmptyFileInput"
                        :isFullWidth="isFullWidth"
                        :selectedDatabase="selectedDatabase"
                        :isAddOnly="isAddOnly"
                        :isAddingNewItem="isAddingNewItem"
                        :draggedElementIdx="draggedElementIdx"
                        :isCreateCustomDB="isCreateCustomDB"
                        :hasFooter="hasFooter"
                        :isChatGptApiLoader="isChatGptApiLoader"
                        :selectedElement="selectedElement"
                        :isPropsModalVisible="isPropsModalVisible"
                        :createdValue="createdValue"
                        :search="search"
                        @onFileSelected="onFileSelected"
                        @onFileDelete="onFileDelete"
                        @editElement="editElement"
                        @dragover="dragover"
                        @drop="drop"
                        @drag="drag"
                        @removeElement="removeElement"
                        @duplicateElement="duplicateElement"
                        @toggleErrorInForm="toggleErrorInForm"
                        @insertNewElement="insertNewElement"
                        @onElementMoreIconClick="onElementMoreIconClick"
                        @addUiInUiElement="addUiInUiElement"
                        @setChatGptApiLoader="setChatGptApiLoader"
                        @toggleAiDropdown="toggleAiDropdown"
                        @elementInputBlur="onElementInputBlur"
                      />
                    </div>
                    <div class="created-wrapper" v-if="showIdField">
                      <div>
                        <label class="created-label">ID</label>
                        <input
                          class="created-input"
                          :value="idValue"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="created-wrapper" v-if="showCreatedField">
                      <div>
                        <label class="created-label">Erstellt am</label>
                        <input
                          class="created-input"
                          :value="getFormattedDate"
                          disabled
                        />
                      </div>
                    </div>
                  </template>
                </div>
                <div
                  class="drop-zone vertical"
                  v-if="false"
                  :id="getId(rowIdx)"
                  @dragover="dragover"
                  @drop="drop"
                ></div>
              </div>
            </div>
            <input
              v-show="false"
              type="submit"
              value="Submit"
              ref="submitBtn"
            />
          </form>
          <div
            ref="addButton"
            class="add-button-wrapper"
            v-if="isUserHasAccess && isEditable"
          >
            <PlusIconButton
              :disabled="isAddButtonDisabled && isPropsModalVisible"
              @onClick.stop="() => toggleAddDropDown()"
            />
            <div
              ref="dropDown"
              class="drop-down add-element"
              :style="{
                top: `${dropDownTop}px`,
                visibility: isAddElementVisible ? 'visible' : 'hidden',
              }"
            >
              <div @click.stop class="form-element-search-wrapper">
                <img
                  :src="getImgUrl('./search-icon.svg')"
                  class="search-icon"
                />
                <input v-model="searchFormElement" />
              </div>
              <div
                class="add-element-wrapper fancy-scroll"
                @scroll.passive="showScrollbar"
              >
                <div
                  v-for="(type, idx) in selectableTypes"
                  :key="idx"
                  class="item"
                  @click="addElement(type.element, type.name)"
                  v-click-outside="closeAddDropDown"
                  :class="{
                    'item-disabled': isElementDisabled(type.element, type.name),
                  }"
                >
                  <div class="img-wrapper-div">
                    <img :src="getImgUrl(type.icon)" alt="" />
                    <span>
                      {{ type.caption }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <b-dropdown
            id="dropdown-dropleft"
            class="form-builder-element-attributes-label"
            ref="chatGptDropDown"
            v-if="isAskAiUiModalVisible"
            @hide="handleCloseAiPopup"
            @show="handleShowAiPopup"
          >
            <b-dropdown-group @click.stop class="ai-dropdown-wrap">
              <div class="">
                <input
                  type="text"
                  placeholder="Make the text larger, add a title or change the colors of this variation"
                  ref="chatgptInputRef"
                  v-model="chatGptApiInput"
                  @keydown.stop="onGenerateAutomatedCSSKeydown"
                />
                <span class="error">{{ chatGptApiError }}</span>
              </div>
              <button
                class="submit-btn"
                @click.stop="generateAutomatedAICSS"
                :disabled="isChatGptApiLoader"
              >
                <span v-if="!isChatGptApiLoader">Senden</span>
                <div
                  class="custom-table-progress-icon"
                  v-if="isChatGptApiLoader"
                ></div>
              </button>
            </b-dropdown-group>
          </b-dropdown>
        </div>
        <elementProps
          v-if="isPropsModalVisible"
          ref="propsModal"
          :isCreateCustomDB="isCreateCustomDB"
          :databaseMeta="databaseMeta"
          :isEditMode="isEditMode"
          :element="this.selectedElement"
          :elements="elements"
          :existingNames="existingNames"
          :reservedElementKeys="reservedElementKeys"
          :isUserHasAccess="isUserHasAccess"
          :selectedDatabase="selectedDatabase"
          :typeList="typeList"
          :taskName="task?.name"
          :importedSchemaElementIds="importedSchemaElementIds"
          @close="togglePropsModal"
          @changeElement="changeElement"
          @writeMessage="writeMessage"
          @onFileSelected="onFileSelected"
          @onFileDelete="onFileDelete"
          @onFileChange="onFileChange"
          @onSheetFileSelect="$emit('onSheetFileSelect', $event)"
          @addElementAfterConfirm="addElementAfterConfirm"
          @removeElementAfterCancle="removeElementAfterCancle"
          @removeElement="removeElement"
          @requestValidation="updatePropsModalValidationState"
        ></elementProps>
      </div>
    </div>
    <LoadingSpinner v-show="loading" :loadingCaption="'wird gespeichert...'" />
  </div>
</template>

<script>
import LoadingSpinner from '../../components/widgets/LoadingSpinner.vue';
import ElementRenderer from './FormBuilderElementComponent.vue';
import { getWizardData } from '../../utils/helpers';
import { askChatGPT } from '../../services/workflow.service';
import { mapActions } from 'vuex';
import {
  getApiEndpointVersion,
  debouncer,
  getFileExtension,
} from '@/utils/helpers';
import PlusIconButton from '../../components/widgets/PlusIconButton.vue';
import moment from 'moment';
import CommonSwitch from './CommonSwitch.vue';

export default {
  name: 'Form-Builder',
  data() {
    return {
      reservedElementKeys: [
        'id',
        'created',
        'updated',
        'owner',
        'automatedaicss',
        'codelosKanbanOrder',
        'style',
        'cdlsflowid',
        'authorization',
      ],
      selectedElement: null,
      isPropsModalVisible: false,
      activeDropZone: null,
      loading: false,
      isAddElementVisible: false,
      chatGptApiInput: '',
      chatGptApiError: null,
      typeList: [
        {
          name: 'text',
          caption: 'Text',
          icon: './text.svg',
          visibility: 'everyone',
          element: {
            name: 'text',
            label: 'Text ',
            placeholder: 'Text',
            type: 'text',
            value: 'Das ist ein Beispieltext',
            layoutItem: false,
            attributes: {
              errorMessage: '',
            },
            settings: {
              layoutItem: false,
            },
          },
        },
        {
          name: 'number',
          caption: 'Zahl',
          icon: './number.svg',
          visibility: 'everyone',
          element: {
            name: 'zahl',
            label: 'Zahl ',
            placeholder: '1',
            type: 'number',
            value: 1,
            layoutItem: false,
            settings: {
              layoutItem: false,
            },
          },
        },
        {
          name: 'formated number',
          caption: 'formatierte Zahl',
          icon: './number.svg',
          visibility: 'everyone',
          element: {
            name: 'formatiertezahl',
            label: 'formatierte Zahl ',
            placeholder: '1',
            type: 'formatted_number',
            value: 1,
            layoutItem: false,
            settings: {
              layoutItem: false,
              thSep: '.',
              decSep: ',',
              toFixed: 2,
            },
          },
        },
        {
          name: 'email',
          caption: 'E-Mail-Adresse',
          icon: './mail.svg',
          visibility: 'everyone',
          element: {
            name: 'email',
            label: 'Email ',
            placeholder: 'Email',
            type: 'email',
            value: 'info@codelos.io',
            layoutItem: false,
            settings: {
              layoutItem: false,
            },
          },
        },
        {
          name: 'file',
          caption: 'Datei & Medien',
          icon: './file.svg',
          visibility: 'everyone',
          element: {
            name: 'file',
            label: 'File ',
            type: 'file',
            value: '',
            layoutItem: false,
            settings: {
              layoutItem: false,
            },
          },
        },
        {
          name: 'filenew',
          caption: 'Datei & Medien',
          icon: './file.svg',
          visibility: 'everyone',
          element: {
            name: 'filenew',
            label: 'file new',
            type: 'filenew',
            value: null,
            layoutItem: false,
            settings: {
              layoutItem: false,
            },
            attributes: {
              required: false,
            },
          },
        },
        {
          name: 'image',
          caption: 'Statisches Bild',
          icon: './image-icon.svg',
          visibility: 'everyone',
          element: {
            name: 'image',
            label: 'Bild ',
            type: 'image',
            value: '',
            layoutItem: true,
            url: '',
            settings: {
              layoutItem: true,
            },
          },
        },
        {
          name: 'video',
          caption: 'Statisches Video',
          icon: './video-icon.svg',
          visibility: 'everyone',
          element: {
            name: 'video',
            label: 'Video ',
            type: 'video',
            value: '',
            layoutItem: true,
            url: '',
            settings: {
              layoutItem: true,
            },
          },
        },
        {
          name: 'status',
          caption: 'Status',
          icon: './options.svg',
          visibility: 'everyone',
          element: {
            name: 'status',
            label: 'Status ',
            type: 'status',
            value: 'option 1',
            options: [
              { label: 'option 1', value: 'option 1', checked: false },
              { label: 'option 2', value: 'option 2', checked: false },
            ],
            attributes: {
              prefilled: false,
              disabled: false,
              required: false,
            },
            layoutItem: false,
            settings: {
              layoutItem: false,
            },
          },
        },
        {
          name: 'radio',
          caption: 'Optionsfeld',
          icon: './options.svg',
          visibility: 'everyone',
          element: {
            name: 'option',
            label: 'Option ',
            type: 'radio',
            value: 'option 1',
            options: [
              { label: 'option 1', value: 'option 1', checked: true },
              { label: 'option 2', value: 'option 2', checked: false },
            ],
            attributes: {
              prefilled: true,
              disabled: false,
            },
            layoutItem: false,
            settings: {
              layoutItem: false,
            },
          },
        },
        {
          name: 'radiooval',
          caption: 'Optionskasten',
          icon: './radiocard.svg',
          visibility: 'everyone',
          element: {
            name: 'radiooval',
            label: 'Optionskasten  ',
            type: 'radio',
            value: 'option 1',
            options: [
              { label: 'option 1', value: 'option 1', checked: true },
              { label: 'option 2', value: 'option 2', checked: false },
            ],
            attributes: {
              required: true,
              disabled: false,
              appearance: 'oval',
              'v-model': 'picked',
              prefilled: true,
            },
            layoutItem: false,
            settings: {
              layoutItem: false,
            },
          },
        },
        {
          name: 'radiocard',
          caption: 'Optionskarten',
          icon: './checkboxcard.svg',
          visibility: 'everyone',
          element: {
            name: 'radiocard',
            label: 'Optionskarten  ',
            type: 'radio',
            value: 'option 1',
            options: [
              { label: 'option 1', value: 'option 1', checked: true },
              { label: 'option 2', value: 'option 2', checked: false },
            ],
            attributes: {
              required: true,
              disabled: false,
              appearance: 'card',
              'v-model': 'picked',
              isImgShowInBackGround: false,
              isShowTitleAndDescription: false,
              prefilled: true,
            },
            layoutItem: false,
            settings: {
              layoutItem: false,
            },
          },
        },
        {
          name: 'checkbox',
          caption: 'Kontrollkästchen',
          icon: './checkbox.svg',
          visibility: 'everyone',
          element: {
            name: 'kontrollk',
            label: 'Kontrollkästchen ',
            type: 'checkbox',
            value: [],
            options: [
              { label: 'option 1', value: 'option 1', checked: false },
              { label: 'option 2', value: 'option 2', checked: false },
            ],
            attributes: {
              required: false,
            },
            layoutItem: false,
            settings: {
              layoutItem: false,
              min: 0,
              max: 2,
            },
          },
        },
        {
          name: 'checkboxoval',
          caption: 'Kontrollkasten',
          icon: './radiocard.svg',
          visibility: 'everyone',
          element: {
            name: 'checkboxoval',
            label: 'Kontrollkasten  ',
            type: 'checkbox',
            value: [],
            options: [
              { label: 'option 1', value: 'option 1', checked: false },
              { label: 'option 2', value: 'option 2', checked: false },
            ],
            attributes: {
              required: false,
              disabled: false,
              appearance: 'oval',
              'v-model': 'checked',
            },
            layoutItem: false,
            settings: {
              layoutItem: false,
              min: 0,
              max: 2,
            },
          },
        },
        {
          name: 'checkboxcard',
          caption: 'Kontrollkarten',
          icon: './checkboxcard.svg',
          visibility: 'everyone',
          element: {
            name: 'checkboxcard',
            label: 'Kontrollkarten  ',
            type: 'checkbox',
            value: [],
            options: [
              { label: 'option 1', value: 'option 1', img: '', checked: false },
              { label: 'option 2', value: 'option 2', img: '', checked: false },
            ],
            attributes: {
              required: false,
              disabled: false,
              appearance: 'card',
              'v-model': 'checked',
              isImgShowInBackGround: false,
              isShowTitleAndDescription: false,
            },
            layoutItem: false,
            settings: {
              layoutItem: false,
              min: 0,
              max: 2,
            },
          },
        },
        {
          name: 'select',
          caption: 'Dropdown-Menü',
          icon: './dropdown-icon.svg',
          visibility: 'everyone',
          element: {
            name: 'dropdownmenu',
            label: 'Dropdown-Menü  ',
            type: 'select',
            value: '',
            options: [
              { label: 'Auswahl 1', value: 'Wert 1' },
              { label: 'Auswahl 2', value: 'Wert 2' },
            ],
            attributes: {
              required: true,
              disabled: false,
              appearance: 'oval',
              'v-model': 'picked',
            },
            settings: {},
            layoutItem: false,
          },
        },
        {
          name: 'date',
          caption: 'Datum',
          icon: './date.svg',
          visibility: 'everyone',
          element: {
            name: 'datum',
            label: 'Datum ',
            placeholder: 'Datum',
            type: 'date',
            value: '2025-01-01',
            layoutItem: false,
            attributes: {
              todayAsDefaultValue: false,
            },
            settings: {
              layoutItem: false,
            },
          },
        },
        {
          name: 'datetime-local',
          caption: 'Datum & Uhrzeit',
          icon: './datetime.svg',
          visibility: 'everyone',
          element: {
            name: 'datumuhrzeit',
            label: 'Datum & Uhrzeit ',
            placeholder: 'Datum & Uhrzeit',
            type: 'datetime-local',
            value: '2025-01-01T01:00',
            layoutItem: false,
            settings: {
              layoutItem: false,
            },
            attributes: {
              todayAsDefaultValue: false,
            },
          },
        },
        {
          name: 'textarea',
          caption: 'Textbereich',
          icon: './textarea.svg',
          visibility: 'everyone',
          element: {
            name: 'textfeld',
            label: 'Textfeld ',
            placeholder: 'Textfeld',
            type: 'textarea',
            value: 'Das ist ein Beispieltext in einem Textfeld.',
            layoutItem: false,
            settings: {
              layoutItem: false,
            },
          },
        },
        {
          name: 'objectlist',
          caption: 'Liste',
          icon: './list.svg',
          visibility: 'everyone',
          element: {
            name: 'objectlist',
            label: 'Liste  ',
            type: 'objectlist',
            value: [],
            schema: [],
            layoutItem: false,
            settings: {
              layoutItem: false,
            },
          },
        },
        {
          name: 'smartmessage',
          caption: 'Smart message',
          icon: './ai-icon.svg',
          visibility: 'everyone',
          element: {
            name: 'smartmessage',
            label: 'Smart Message  ',
            placeholder: 'Textfeld',
            type: 'smartmessage',
            value: 'kannst du mir eine Zusammenfassung über die Daten machen?',
            layoutItem: false,
            settings: {
              layoutItem: false,
            },
          },
        },
        {
          name: 'range',
          caption: 'Schieberegler',
          icon: './range-icon.svg',
          visibility: 'everyone',
          element: {
            name: 'schieberegler',
            label: 'Schieberegler  ',
            placeholder: '',
            type: 'range',
            value: 15,
            attributes: {
              min: 1,
              max: 100,
              required: false,
            },
            layoutItem: false,
            settings: {
              layoutItem: false,
            },
          },
        },
        {
          name: 'barcode',
          caption: 'Barcode',
          icon: './mail.svg',
          visibility: 'hidden',
          layoutItem: false,
          settings: {
            layoutItem: false,
          },
        },
        {
          name: 'qrcode',
          caption: 'QR-Code',
          icon: './mail.svg',
          visibility: 'hidden',
          layoutItem: false,
          settings: {
            layoutItem: false,
          },
        },
        {
          name: 'foto',
          caption: 'Foto',
          icon: './mail.svg',
          visibility: 'hidden',
          layoutItem: false,
          settings: {
            layoutItem: false,
          },
        },
        {
          name: 'location',
          caption: 'Standort',
          icon: './mail.svg',
          visibility: 'hidden',
          layoutItem: false,
          settings: {
            layoutItem: false,
          },
        },
        {
          name: 'html',
          caption: 'html',
          icon: './html.svg',
          visibility: 'admin',
          element: {
            name: 'html',
            label: 'HTML ',
            placeholder: 'HTML',
            type: 'html',
            value: '<div>Beispieldiv</div>',
            layoutItem: true,
            settings: {
              layoutItem: true,
              isHtmlRendered: false,
            },
          },
        },
        {
          name: 'hidden',
          caption: 'hidden',
          icon: './hidden.svg',
          visibility: 'everyone',
          element: {
            name: 'hidden',
            label: 'hidden ',
            placeholder: 'hidden',
            type: 'hidden',
            value: 'Verstecktes Feld',
            layoutItem: false,
            settings: {
              layoutItem: false,
            },
          },
        },
        {
          name: 'model',
          caption: 'model',
          icon: './database-model.svg',
          visibility: 'admin',
          element: {
            name: 'model',
            label: 'Model ',
            placeholder: 'Model',
            type: 'model',
            value: 'model-id',
            layoutItem: false,
            settings: {
              layoutItem: false,
            },
          },
        },
        {
          name: 'databaseid',
          caption: 'Database id',
          icon: './database-model.svg',
          visibility: 'admin',
          element: {
            name: 'databaseid',
            label: 'Database id ',
            placeholder: 'Database id',
            type: 'databaseid',
            value: 'database-id',
            layoutItem: false,
            settings: {
              layoutItem: false,
            },
          },
        },
        {
          name: 'title',
          caption: 'Titel',
          icon: './title.svg',
          visibility: 'everyone',
          element: {
            name: 'title',
            label: 'Titel  ',
            placeholder: '',
            type: 'title',
            value: '',
            layoutItem: true,
            settings: {
              layoutItem: false,
            },
          },
        },
        {
          name: 'description',
          caption: 'Beschreibungstext',
          icon: './description.svg',
          visibility: 'everyone',
          element: {
            name: 'description',
            label: 'Beschreibungstext  ',
            placeholder: '',
            type: 'description',
            value: '',
            layoutItem: true,
            settings: {
              layoutItem: true,
            },
          },
        },
        {
          name: 'horizontalrule',
          caption: 'Trennlinie',
          icon: './line.svg',
          visibility: 'everyone',
          element: {
            name: 'horizontalrule',
            label: 'Trennlinie  ',
            placeholder: '',
            type: 'horizontalrule',
            value: '',
            layoutItem: true,
            settings: {
              layoutItem: true,
            },
          },
        },
        {
          name: 'toggleliststart',
          caption: 'Klappliste',
          icon: './toggle.svg',
          visibility: 'everyone',
          element: {
            name: 'toggleliststart',
            label: 'Klappliste-Start  ',
            type: 'togglelist',
            value:
              // "<label class='collapsible-{increment}'>{label}</label>\n<div class='content'>\n",
              "<div class='c-wrap mb-3 collapsible-{increment}'>\n<label class='accordion-list-label form-label mb-3 collapsible-{increment}' for='collapsible-{increment}' data-bs-toggle='collapse' data-bs-target='#collaps-wrapper-{increment}' aria-expanded='false' aria-controls='collaps-wrapper-{increment}'>{label}</label>\n<div class='accordion-list collapse' id='collaps-wrapper-{increment}'>\n<div class='content' id={toggle_list_id}>\n",

            layoutItem: true,
            settings: {
              layoutItem: true,
            },
          },
        },
        {
          name: 'wrapperstart',
          caption: 'Wrapper',
          icon: './toggle.svg',
          visibility: 'everyone',
          element: {
            name: 'wrapper-{increment}-start',
            label: 'Wrapper-Start  ',
            type: 'wrapper',
            value: '',
            layoutItem: true,
            settings: {
              layoutItem: true,
            },
          },
        },
        {
          name: 'sheet',
          caption: 'Blatt',
          icon: './file.svg',
          visibility: 'everyone',
          isInternalUseOnly: true,
          element: {
            name: 'sheet',
            label: 'sheet',
            type: 'sheet',
            value: null,
            layoutItem: false,
            settings: {
              layoutItem: false,
            },
          },
        },
        {
          name: 'wizard',
          caption: 'wizard',
          icon: './wizard.svg',
          visibility: 'everyone',
          element: {
            name: 'wizardtab',
            label: 'tab  ',
            placeholder: '',
            type: 'title',
            value: '',
            layoutItem: true,
            defaultTabs: 4,
            settings: {
              layoutItem: true,
            },
          },
        },
        {
          name: 'linktodatabase',
          caption: 'Link-zur-Datenbank',
          icon: './link-to-db.svg',
          visibility: 'everyone',
          element: {
            name: 'link',
            label: 'link',
            placeholder: '',
            value: null,
            layoutItem: false,
            type: 'linktodb',
            selectedDatabaseCaption: null,
            selectedDatabaseID: null,
            selectedDatabaseType: null,
            settings: {
              layoutItem: false,
            },
          },
        },
        {
          name: 'freecontent',
          caption: 'Free Content',
          icon: './title.svg',
          visibility: 'everyone',
          element: {
            name: 'freecontent',
            label: 'freecontent',
            placeholder: '',
            type: 'freecontent',
            value: '',
            layoutItem: false,
          },
        },
        {
          name: 'timestampms',
          caption: 'Zeitstempel',
          icon: './datetime.svg',
          visibility: 'everyone',
          element: {
            name: 'timestampms',
            label: 'Zeitstempel ',
            placeholder: '1',
            type: 'timestampms',
            value: Date.now(),
            layoutItem: false,
          },
        },
        {
          name: 'databaselinkedview',
          caption: 'Datenbankverknüpfung ',
          icon: './link-to-db.svg',
          visibility: 'everyone',
          element: {
            name: 'databaselinkedview',
            label: 'databaselinkedview',
            placeholder: '',
            value: null,
            layoutItem: false,
            type: 'databaselinkedview',
            databaseLink: {},
            settings: {
              connectedDatabase: {
                selectedDatabaseCaption: null,
                selectedDatabaseID: null,
                selectedDatabaseType: null,
                selectedDatabaseColumn: [],
              },
              layoutItem: false,
            },
          },
        },
        {
          name: 'automatedaicss',
          caption: 'automatedaicss',
          icon: './html.svg',
          visibility: 'hidden',
          element: {
            name: 'automatedaicss',
            label: 'Automated AI CSS ',
            placeholder: 'automatedaicss',
            type: 'automatedaicss',
            value: '',
            settings: {
              layoutItem: true,
            },
          },
        },
        {
          name: 'resultwindow',
          caption: 'Ergebnisfenster',
          icon: './result-window.svg',
          visibility: 'everyone',
          element: {
            name: 'resultwindow',
            label: 'Ergebnisfenster',
            type: 'resultwindow',
            value: null,
            layoutItem: true,
          },
        },
      ],
      mutableElements: null,
      mutableStructure: null,
      selectedElementID: null,
      dropDownTop: 200,
      draggedElementIdx: null,
      isErrorInForm: false,
      searchFormElement: '',
      isNewFormElement: {
        idx: -1,
        type: null,
        isWizard: false,
      },
      isPageEditorElementDragging: false,
      isChatGptApiLoader: false,
      isAddButtonDisabled: false,
      elementSearch: null,
      renameConfirmModalData: {
        elementName: null,
        defaultElement: null,
      },
    };
  },
  props: {
    elements: Array,
    structure: {
      type: Object,
      default: () => ({
        tabs: [{ id: 0, rows: [{ id: 0, cols: [{ id: 0 }] }] }],
      }),
    },
    isFullWidth: Boolean,
    isEditable: Boolean,
    isEditMode: { type: Boolean, default: false },
    isContentEditable: Boolean,
    elsToShow: Array,
    isCreateCustomDB: Boolean,
    isUserHasAccess: { type: Boolean, default: true },
    isAddingNewItem: {
      type: Boolean,
      default: false,
    },
    selectedDatabase: {
      type: Object,
      default: () => null,
    },
    isAddOnly: {
      type: Boolean,
      default: false,
    },
    search: {
      type: String,
      default: '',
    },
    databaseMeta: {
      type: Object,
    },
    hasFooter: { type: Boolean, default: false },
    elementsToHide: {
      type: Array,
      required: false,
      default: () => [],
    },
    isCalledInElementsProps: {
      type: Boolean,
      default: false,
    },
    isHtmlElementVisible: {
      type: Boolean,
      default: true,
    },
    isAskAiUiModalVisible: {
      type: Boolean,
      deafult: false,
    },
    flowRunnerEndpoint: {
      type: String,
      required: false,
      default: process.env.VUE_APP_FLOW_RUNNER_API,
    },
    formulaVersion: {
      type: Number,
    },
    elementInputs: {
      type: Array,
      required: false,
      deafult: [],
    },
    createdValue: {
      type: Number | String,
      required: false,
      default: null,
    },
    idValue: {
      type: Number | String,
      required: false,
      default: null,
    },
    isCopyDatabaseItem: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSideBarLinkItem: { type: Boolean, default: false },
    importedSchemaElementIds: { type: Array, default: () => [] },
    process: Object,
    task: Object,
  },
  methods: {
    ...mapActions(['checkTokenRefresh']),
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
      });
    },
    isElementDisabled(ele, name) {
      if (name === 'wizard') {
        return this.elements.some((el) => el.defaultTabs);
      }
      if (name === 'resultwindow') {
        return this.elements.some((el) => el.type === 'resultwindow');
      }
      if (name === 'status' && this.isDatabaseContext) {
        return this.elements.some((el) => el.type === 'status');
      }

      return false;
    },
    showElements(element) {
      const type = element.type;
      if (type === 'status' && !this.isDatabaseContext) return false;
      let filterCondition = true;
      const isRendered = !!element?.settings?.isHtmlRendered;
      let searchElement = this.elementSearch
        ? this.elementSearch
        : this.search
        ? this.search
        : null;
      if (searchElement) {
        filterCondition = element.label
          .toLowerCase()
          .includes(searchElement.toLowerCase());
      }
      if (type === 'html') {
        if (!this.isUserHasAccess) {
          return false;
        } else if (this.isAdmin && !isRendered) {
          return this.isHtmlElementVisible && filterCondition;
        }
      }
      if (type === 'automatedaicss') return false;
      const restrictedTypes = ['model', 'databaseid'];
      const show = !restrictedTypes.includes(type) || this.isAdmin;
      return show && filterCondition;
    },
    close() {
      this.$emit('close');
    },
    drag(event, id) {
      if (event.target.classList.contains('element-block')) {
        this.isPageEditorElementDragging = true;
      }
      this.draggedElementIdx = id;
    },
    dragover(event, id) {
      if (this.isPageEditorElementDragging) {
        return;
      }
      this.activeDropZone = id.toString();
      event.preventDefault();
    },

    drop(event, targetIdx) {
      this.isPageEditorElementDragging = false;
      if (this.isEditable) {
        // Get relevant data from event
        const dropZone = event.target.classList[1];

        const selectedItem = this.mutableElements[this.draggedElementIdx];
        // Handle new cols
        if (dropZone == 'vertical') {
          let tab = this.activeTab;
          let row = targetIdx;
          let path = this.mutableStructure['tabs'][tab]['rows'][row]['cols'];

          // Update the draged item
          selectedItem.structure.col = path.length;

          // Create new col
          this.$set(path, path.length, { id: path.length });
        } else if (
          this.draggedElementIdx != null &&
          this.activeDropZone != null
        ) {
          const selected = this.mutableElements.splice(
            this.draggedElementIdx,
            1
          )[0];
          this.mutableElements.splice(this.activeDropZone, 0, selected);
        }
        setTimeout(() => {
          this.setFileInputs();
        });
        this.activeDropZone = null;
        this.draggedElementIdx = null;
      }
    },
    togglePropsModal() {
      this.isPropsModalVisible = !this.isPropsModalVisible;
    },
    addSingleElement(elementDefaults) {
      if (
        elementDefaults.type === 'image' ||
        elementDefaults.type === 'video'
      ) {
        this.isPropsModalVisible = true;
      }
      var elementBase = {
        id: this.newID(),
        default: false,
        highlight: false,
        settings: {
          default: false,
          highlight: false,
        },
        options: [],
        structure: {
          tab: 0,
          row: 0,
          col: 0,
        },
        attributes: {
          required: true,
          disabled: false,
        },
      };

      // Create deepcopies of both elements
      let elBase = JSON.parse(JSON.stringify(elementBase));
      let elDefaults = JSON.parse(JSON.stringify(elementDefaults));

      // Merge base & predefined values
      let e = {
        ...elBase,
        ...elDefaults,
        settings: { ...elDefaults.settings, ...elBase.settings },
      };

      // Add tabindex to all non-layout items
      // TODO: Remove attr from Base and add baseAttr only when not layoutItem
      if (!this.getElementSettings(elementDefaults, 'layoutItem'))
        e.attributes.tabindex = '';

      // Create copy of final element
      let el = JSON.parse(JSON.stringify(e));

      // Add unique number to el.name
      let incNum = this.getIncrementNum(el.type);
      if (el.type == 'wrapper') {
        el.name = el.name.replaceAll('{increment}', incNum);
      } else {
        el.name += incNum;
        el.name = this.createUniqueName(el.name, incNum + 1);
      }
      el.label += incNum;
      el.label = this.createUniqueLabel(el.label, incNum + 1);

      if ('attributes' in el && el.type !== 'filenew') {
        el.attributes.required = true;
      }
      if('attributes' in el && el.type == 'status'){
        el.attributes.required =  false
      }

      // Handle togglelist-start
      if (el.type == 'togglelist')
        el.value = el.value.replaceAll('{increment}', incNum);

      if (!(this.isNewFormElement.idx >= 0)) {
        // Push new element to flow
        this.mutableElements.push(el);
        this.selectedElement = el;

        // Handle togglelist-end
        if (el.type == 'togglelist') {
          const toggleEnd = this.getToggleListEnd(el, incNum);
          this.mutableElements.push(toggleEnd);
        }
        // Handle wrapper-end
        if (el.type == 'wrapper') {
          const wrapperEnd = this.getWrapperEnd(el);
          this.mutableElements.push(wrapperEnd);
        }

        this.$nextTick(function () {
          this.$refs.formBuilderElementWraper[0].scrollTop =
            this.$refs.formBuilderElementWraper[0].scrollHeight;
        });
      } else {
        //insertElement top and bottom
        const index = this.isNewFormElement.idx;
        if (this.isNewFormElement.type == 'top') {
          //insert before
          this.mutableElements.splice(index, 0, el);
          this.selectedElement = el;

          // Handle togglelist-end
          if (el.type == 'togglelist') {
            const toggleEnd = this.getToggleListEnd(el, incNum);
            this.mutableElements.splice(index + 1, 0, toggleEnd);
          }
          // Handle wrapper-end
          if (el.type == 'wrapper') {
            const wrapperEnd = this.getWrapperEnd(el);
            this.mutableElements.splice(index + 1, 0, wrapperEnd);
          }
        } else if (this.isNewFormElement.type == 'bottom') {
          //insert after
          this.mutableElements.splice(index + 1, 0, el);
          this.selectedElement = el;

          // Handle togglelist-end
          if (el.type == 'togglelist') {
            const toggleEnd = this.getToggleListEnd(el, incNum);
            this.mutableElements.splice(index + 2, 0, toggleEnd);
          }
          // Handle wrapper-end
          if (el.type == 'wrapper') {
            const wrapperEnd = this.getWrapperEnd(el);
            this.mutableElements.splice(index + 2, 0, wrapperEnd);
          }
        }

        if (!this.isNewFormElement.isWizard) {
          this.isNewFormElement.idx = -1;
          this.isNewFormElement.type = null;
          this.isNewFormElement.isWizard = false;
        }
      }
    },
    addElement(elementDefaults, elementName) {
      if (!this.isElementDisabled(elementDefaults, elementName)) {
        if (this.checkUserNameChanged) {
          this.renameConfirmModalData.elementName = elementName;
          this.renameConfirmModalData.defaultElement = elementDefaults;
          return;
        }
        if (elementName === 'wizard') {
          const defaultHtmlArray = getWizardData();
          if (this.isNewFormElement.idx >= 0) {
            this.isNewFormElement.isWizard = true;
          }
          for (
            let index = 0;
            index <= elementDefaults.defaultTabs - 1;
            index++
          ) {
            this.addSingleElement(elementDefaults);
            if (this.isNewFormElement.isWizard) {
              this.isNewFormElement.idx++;
            }
          }

          for (
            let htmlIndex = 0;
            htmlIndex < defaultHtmlArray.length;
            htmlIndex++
          ) {
            this.addSingleElement(defaultHtmlArray[htmlIndex]);
            if (this.isNewFormElement.isWizard) {
              if (htmlIndex == defaultHtmlArray.length - 1)
                this.isNewFormElement.isWizard = false;
              this.isNewFormElement.idx++;
            }
          }
        } else {
          this.isNewFormElement.isWizard = false;
          this.addSingleElement(elementDefaults);
        }

        // Hide dropdown
        this.toggleAddDropDown();
        setTimeout(() => {
          this.setFileInputs();
        });
      }
    },
    getToggleListEnd(el, incNum) {
      // Create deepcopy
      let e = JSON.parse(JSON.stringify(el));

      // Turn start into end
      e.name = el.name.replace('start', 'end');
      e.label = el.label.replace('Start', 'Ende');
      // ATTENTION: / (slashs) in both <\/script> end tags must be delimited using \ after each format of the document
      e.value = '</div>\n</div>\n</div>\n';
      // eslint-disable-next-line no-useless-escape
      // '</div>\n<style>\n.collapsible-{increment}:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.content {\n  display: none;\n  overflow: hidden;\n}\n</style>\n<script>\nvar coll = document.getElementsByClassName("collapsible-{increment}");\nvar i;\n\nfor (i = 0; i < coll.length; i++) {\n  coll[i].addEventListener("click", function() {\n    this.classList.toggle("active");\n    var content = this.nextElementSibling;\n    if (content.style.display === "block") {\n      content.style.display = "none";\n    } else {\n      content.style.display = "block";\n    }\n  });\n}\n<\/script>';
      // e.value = e.value.replaceAll('{increment}', incNum);
      return e;
    },
    getWrapperEnd(el) {
      // Create deepcopy
      let e = JSON.parse(JSON.stringify(el));

      // Turn start into end
      e.name = el.name.replace('start', 'end');
      e.label = el.label.replace('Start', 'Ende');

      return e;
    },
    removeElement(element) {
      var name = element.name;

      // If we remove selected element, unselect and close edit modal
      if (this.selectedElement && this.selectedElement.id == element.id) {
        this.isPropsModalVisible = false;
        this.selectedElement = null;
      }

      // For togglelist and div wrapper we always remove start & end
      if (!['togglelist', 'wrapper'].includes(element.type)) {
        this.mutableElements = this.mutableElements.filter((el) => {
          return el.name != name;
        });
      } else {
        this.mutableElements = this.mutableElements.filter((el) => {
          return el.id != element.id;
        });
      }
      setTimeout(() => {
        this.setFileInputs();
      });
    },
    createUniqueName(name, num) {
      if (!this.existingNames.includes(name)) {
        return name;
      } else {
        if (this.existingNames.includes(name)) {
          name = name.replace(/[0-9]*$/, '');
          name += num;
        }

        return this.createUniqueName(name, ++num);
      }
    },
    createUniqueLabel(label, num) {
      if (!this.existingLabels.includes(label)) {
        return label;
      } else {
        if (this.existingLabels.includes(label)) {
          label = label.replace(/[0-9]*$/, '');
          label += num;
        }

        return this.createUniqueLabel(label, ++num);
      }
    },
    duplicateElement(e, idx) {
      let el = JSON.parse(JSON.stringify(e));
      // If last char is num replace
      const nameTailingNumbers = el.name.match(/\d+$/)
        ? parseInt(el.name.match(/\d+$/)[0])
        : 1;
      const labelTailingNumbers = el.label.match(/\d+$/)
        ? parseInt(el.label.match(/\d+$/)[0])
        : 1;

      // Add number and check element.name and element.label is unique
      el.name = this.createUniqueName(el.name, nameTailingNumbers + 1);
      el.label = this.createUniqueLabel(el.label, labelTailingNumbers + 1);
      el.id = this.newID();
      if ('showcaseField' in el.settings) el.settings.showcaseField = false;
      this.mutableElements.splice(idx + 1, 0, el);
      setTimeout(() => {
        this.setFileInputs();
      });
    },
    getImgUrl(img) {
      const images = require.context('../../assets/img/', false, /\.svg$/);

      return images(img);
    },
    getBuildUrl(img, type) {
      try {
        if (!type || ['custom', 'illustration'].includes(type)) return img;
        else if (type == 'icon') {
          const icons = require.context(
            '../../assets/img/icons/',
            false,
            /\.svg$/
          );
          return icons(img);
        } else return '';
      } catch (e) {
        return '';
      }
    },
    newID() {
      return Math.round(Math.random() * 100000 + new Date().getTime());
    },

    isEmptyFileInput(name) {
      let fileInputs = this.elements.filter(
        (e) => e.type == 'file' && e.files != '[object FileList]'
      );
      let fileInputNames = fileInputs.map((e) => e.label);
      return fileInputNames.includes(name);
    },
    getIncrementNum(type) {
      let currentNums = [];
      let typeArr = [...this.elementInputsProp, ...this.elements].filter(
        (e) => e.type == type
      );

      if (typeArr.length > 0) {
        typeArr.forEach((e) => {
          let num = e.name.match(/\d+/g);
          if (!isNaN(parseInt(num))) currentNums.push(num[0]);
        });

        if (currentNums.length == 0) return 1;
        return Math.max(...currentNums) + 1;
      } else return 1;
    },
    checkboxValidation(element, isToast) {
      let totalChecked = element.options.filter(
        (option) => option.checked
      ).length;

      const minSelectables = element.settings.min;
      const maxSelectables = element.settings.max;

      if (
        minSelectables < 0 ||
        maxSelectables < 0 ||
        minSelectables > element.options.length ||
        maxSelectables > element.options.length ||
        (minSelectables && !/^[0-9]+$/.test(minSelectables)) ||
        ((maxSelectables || maxSelectables === 0) &&
          !/^[0-9]+$/.test(maxSelectables)) ||
        !this.isValidSelectedElementName()
      ) {
        return false;
      }

      if (totalChecked < element.settings.min) {
        if (isToast) {
          this.showToaster(
            `Es dürfen mindestens ${element.settings.min}“ Auswahlen ausgewählt werden.`,
            'Fehlerhaft !',
            'danger'
          );
        }
        return false;
      } else if (
        element.settings.max !== '' &&
        totalChecked > element.settings.max
      ) {
        if (isToast) {
          this.showToaster(
            `Es dürfen maximal ${element.settings.max} Auswahlen ausgewählt werden.`,
            'Fehlerhaft !',
            'danger'
          );
        }
        return false;
      } else {
        return true;
      }
    },
    validateSelectableElementOptions(element) {
      const labels = element.options.map((option) => option.label);
      const uniqueLabels = new Set(labels);
      const isUniqueLabels = labels.length === uniqueLabels.size;
      if (!isUniqueLabels) {
        return isUniqueLabels;
      }
      if (element.type === 'status') {
        const values = element.options.map((option) => option.value);
        const uniqueValues = new Set(values);
        const isUniqueValues = values.length === uniqueValues.size;
        if (!isUniqueValues) {
          return false;
        }
      }
      const isInvalidOptionValue = element.options.some(
        (option) => !option.value
      );
      return isUniqueLabels && !isInvalidOptionValue;
    },
    radioButtonValidation(element, isToast) {
      if (this.isValidSelectedElementName()) {
        for (const option of element.options) {
          if (option.checked) {
            return true;
          }
        }
        if (isToast) {
          this.showToaster(
            'Bitte wählen Sie eine dieser Optionen',
            'Fehlerhaft !',
            'danger'
          );
        }
      }
      return false;
    },
    formValidation(isToast = true) {
      if (
        this.isPropsModalVisible &&
        this.selectedElement.type === 'objectlist'
      ) {
        for (const elem of this.selectedElement.schema) {
          if (['radio', 'status', 'checkbox', 'select'].includes(elem.type)) {
            const isValidOptions = this.validateSelectableElementOptions(elem);
            if (elem.type === 'checkbox' && !elem.attributes.disabled) {
              return this.checkboxValidation(elem, isToast) && isValidOptions;
            } else {
              return isValidOptions;
            }
          }
        }
        return true;
      } else if (
        this.isPropsModalVisible &&
        ['radio', 'status', 'checkbox', 'select'].includes(
          this.selectedElement.type
        )
      ) {
        // validate selectable element options
        const isValidOptions = this.validateSelectableElementOptions(
          this.selectedElement
        );

        // validate value required or not and min max validation
        if (
          this.selectedElement.type === 'checkbox' &&
          !this.selectedElement.attributes.disabled
        ) {
          return (
            this.checkboxValidation(this.selectedElement, isToast) &&
            isValidOptions
          );
        } else {
          return isValidOptions;
        }
      } else if (
        this.isPropsModalVisible &&
        this.selectedElement.type === 'range'
      ) {
        return this.checkRangeSelectionValidtion(this.selectedElement);
      } else if (
        this.isPropsModalVisible &&
        this.selectedElement?.type === 'databaselinkedview' &&
        (this.selectedElement?.settings?.connectedDatabase
          ?.selectedDatabaseID === undefined ||
          this.$refs?.propsModal?.selectedDatabaseColumn?.length === 0 ||
          (this.$refs?.propsModal?.getSelectedDatabaseFields?.length !== 0 &&
            this.selectedElement?.databaseLink?.currentTableFieldKey ===
              undefined))
      ) {
        return false;
      } else if (
        this.isPropsModalVisible &&
        this.selectedElement.type === 'number'
      ) {
        return this.numberElementValidation(this.selectedElement);
      } else if (
        !this.isValidSelectedElementName() ||
        (this.isPropsModalVisible && !this.isValidSelectedElementValue())
      ) {
        return false;
      } else if (
        this.isPropsModalVisible &&
        this.isCreateCustomDB &&
        this.elements?.find((elem) => elem.label === '')
      ) {
        return false;
      } else {
        return true;
      }
    },
    isValidSelectedElementName() {
      return !(
        this.selectedElement?.name === '' ||
        this.existingNames
          .concat(this.reservedElementKeys)
          .filter((e) => e === this.selectedElement?.name).length > 1 ||
        !/^[a-z0-9äöü]+$/.test(this.selectedElement?.name)
      );
    },
    isValidSelectedElementValue() {
      const isElementValueRequired = this.selectedElement?.attributes?.required;
      if (
        [
          'number',
          'text',
          'textarea',
          'date',
          'datetime-local',
          'model',
        ].includes(this.selectedElement?.type) &&
        isElementValueRequired &&
        !this.isCreateCustomDB
      ) {
        if (this.selectedElement.type === 'number') {
          return this.selectedElement.value || this.selectedElement.value == 0;
        } else if (this.selectedElement.type === 'file') {
          return this.selectedElement?.files?.length ? true : false;
        } else if (this.selectedElement.type === 'text') {
          const pattern = new RegExp(this.selectedElement?.attributes?.pattern);
          return pattern?.test(this.selectedElement?.value);
        } else {
          return this.selectedElement.value;
        }
      } else if (this.selectedElement.type == 'email') {
        if (
          (isElementValueRequired && this.isCreateCustomDB) ||
          !isElementValueRequired
        ) {
          return this.selectedElement.value
            ? this.isValidEmail(this.selectedElement.value)
            : true;
        } else {
          return !this.selectedElement.value
            ? false
            : this.isValidEmail(this.selectedElement.value);
        }
      }

      return true;
    },
    isValidEmail(email) {
      const emailPattern = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
      return emailPattern.test(email);
    },
    numberElementValidation(element) {
      const min =
        (element.attributes.min && Number(element.attributes.min)) ?? '';
      const max =
        (element.attributes.max && Number(element.attributes.max)) ?? '';
      const isValidNameAndLabel =
        this.isValidSelectedElementName() && this.isValidSelectedElementValue();

      if (min !== '' && max !== '' && min >= max) {
        return false;
      }

      if (
        element.attributes.required &&
        !this.isCreateCustomDB &&
        element.value !== 0 &&
        !element.value
      )
        return false;

      if (!element.attributes.required && element.value !== 0 && !element.value)
        return isValidNameAndLabel;
      const value = Number(element.value);

      const isWithinRange =
        (min === '' || value >= min) && (max === '' || value <= max);

      return (
        ((this.isCreateCustomDB && value == 0) || isWithinRange) &&
        isValidNameAndLabel
      );
    },
    toggleAddDropDown() {
      const validate = this.formValidation();
      if (!validate) {
        return;
      }
      if (
        this.$refs.addButton.offsetTop - this.$refs.formContainer.offsetTop <=
        this.$refs.dropDown.clientHeight
      ) {
        this.dropDownTop = this.$refs.formContainer.offsetTop;
      } else {
        this.dropDownTop =
          this.$refs.formContainer.offsetTop +
          (this.$refs.addButton.offsetTop -
            this.$refs.formContainer.offsetTop -
            (this.$refs.dropDown.clientHeight - 100));
      }
      this.closeAiInputModal();
      if (this.isAskAiUiModalVisible) {
        this.$emit('showAskAiUiModal');
      }
      this.isAddElementVisible = !this.isAddElementVisible;
      this.searchFormElement = '';
    },
    closeAiInputModal() {
      if (this.isAskAiUiModalVisible) {
        for (const element of this.filteredMutableElements) {
          if (
            this.$refs[`formElements${element.id}`] &&
            this.$refs[`formElements${element.id}`][0] &&
            this.$refs[`formElements${element.id}`][0].closeAiPopup
          ) {
            this.$refs[`formElements${element.id}`][0].closeAiPopup();
          }
        }
      }
    },
    addMissingAttributes() {
      // Add structure to each element
      for (let el of this.mutableElements) {
        if (!el.hasOwnProperty('structure')) {
          el.structure = { tab: 0, row: 0, col: 0 };
        }
      }
    },
    validateInputs() {
      if (this.isErrorInForm) return false;
      if (!this.checkSelectDropdownValidation()) return false;
      if (this.isEditable) this.$emit('saveItem', this.mutableElements);
      else
        this.$emit(
          'saveItem',
          this.mutableElements?.reduce((acc, cur) => {
            if (
              ['togglelist', 'wrapper'].includes(cur.type) &&
              cur.name.includes('start')
            ) {
              const elements = cur.elements;
              delete cur.elements;
              acc = [...acc, cur, ...elements];
            } else acc.push(cur);
            return acc;
          }, [])
        );
    },
    validateRequiredElementsByType(type) {
      return this.getMutableElements
        .filter(
          (element) => element.type === type && element.attributes.required
        )
        .every((element) => {
          if (type === 'objectlist') {
            return element.value && element.value.length > 0;
          } else {
            return element.value;
          }
        });
    },
    formSubmit() {
      if (!this.$refs.customdbFrom.checkValidity()) {
        if (this.isAddingNewItem && this.search?.length > 0) {
          this.showToaster(
            `In einigen Pflichtfeldern fehlen Werte. Dies kann daran liegen, dass der aktuelle Suchfilter diese Werte ausblendet. Bitte löschen Sie die Suche und füllen Sie alle Pflichtfelder aus.`,
            'Fehlerhaft !',
            'danger'
          );
          return;
        }
        if (!this.checkSelectDropdownValidation()) return false;
        const toggleId = this.$refs.customdbFrom
          .querySelectorAll(':invalid')[0]
          .closest('.content').id;

        if (
          toggleId &&
          !this.$refs[`formElements${toggleId}`][0].opennedTogglelist.includes(
            toggleId
          )
        )
          this.$refs[`formElements${toggleId}`][0].opennedTogglelist.push(
            toggleId
          );
      }

      if (!this.validateRequiredElementsByType('filenew')) {
        this.showToaster(
          'Bitte wählen Sie eine Datei aus, bevor Sie das Formular absenden.',
          'Fehlerhaft !',
          'danger'
        );
        return;
      } else if (!this.validateRequiredElementsByType('objectlist')) {
        this.showToaster(
          'Bitte fügen Sie vor dem Absenden des Formulars mindestens ein Objektlisten-Element hinzu.',
          'Fehlerhaft !',
          'danger'
        );
        return;
      } else if (!this.validateRequiredElementsByType('linktodb')) {
        this.showToaster(
          'Wählen Sie einen Eintrag im Datenverknüpfungsfeld aus.',
          'Fehlerhaft !',
          'danger'
        );
        return;
      }
      setTimeout(() => {
        this.$refs.submitBtn.click();
      }, 50);
    },
    editElement(element) {
      if (
        this.isPropsModalVisible &&
        element.type === 'objectlist' &&
        this.selectedElement.type === 'objectlist'
      ) {
        this.$refs.propsModal.$refs.formBuilder.isPropsModalVisible = false;
      }

      if (
        this.isPropsModalVisible &&
        !this.isCalledInElementsProps &&
        this.$refs?.propsModal?.isOverFlowHidden
      ) {
        this.$refs.propsModal.isOverFlowHidden = false;
      }
      let elNeedsValidation =
        this.isPropsModalVisible &&
        element?.name !== this.selectedElement?.name;
      // Toggle only if not visible
      if (!this.isPropsModalVisible) {
        this.isPropsModalVisible = true;
        this.selectedElement = element;
      }

      // Add element without validation if first time
      if (!this.selectedElement) this.selectedElement = element;

      //To change element or To validate form
      if (elNeedsValidation) {
        this.$refs.propsModal.formSubmit(element);
      }
    },
    changeElement(e) {
      if (e.type === 'checkbox') {
        if (e.settings === undefined) {
          e.settings = {
            min: 0,
            max: e.options.length,
          };
        } else if (
          e.settings.min === undefined ||
          e.settings.max === undefined
        ) {
          e.settings = {
            ...e.settings,
            min: 0,
            max: e.options.length,
          };
        }
      }
      this.selectedElement = e;
    },
    isLargeWrapperRequired(type) {
      return ['textarea', 'html', 'smartmessage'].includes(type);
    },
    async writeMessage(element) {
      if (
        this.mutableElements.length === 1 &&
        this.mutableElements[0].type === 'smartmessage'
      ) {
        this.showToaster(
          'Bitte fügen Sie mindestens ein Element hinzu',
          'Fehlerhaft !',
          'danger'
        );
      } else {
        let question;
        if (
          element.value &&
          element.value !== null &&
          element.value.trim() !== ''
        ) {
          question = ` Frage: ${element.value} \n`;
        } else {
          question = ` Frage: kannst du mir eine Zusammenfassung über die Daten machen? \n `;
        }
        const objectArray = this.mutableElements?.reduce((acc, cur) => {
          if (cur.id != element.id) {
            acc[cur.label] = cur.value;
          }
          return acc;
        }, {});
        const finalMessage =
          question + ` data : ` + JSON.stringify(objectArray);
        try {
          const url = this.flowRunnerEndpoint;
          let res;
          if (getApiEndpointVersion(url) >= 6) {
            const formData = new FormData();
            formData.append(
              'props',
              JSON.stringify({
                prompt: finalMessage,
                model: 'gpt-4',
              })
            );
            res = await askChatGPT(url, formData);
          } else {
            res = await askChatGPT(url, {
              prompt: finalMessage,
            });
          }
          if (res.status != 200) throw new Error(res.statusText);
          const smartMessageIndex = this.mutableElements.findIndex(
            (ele) => ele.id === element.id
          );
          this.selectedElement = {
            ...element,
            value: res.data.message,
          };
          this.mutableElements.splice(
            smartMessageIndex,
            1,
            this.selectedElement
          );
        } catch (err) {
          throw new Error(err);
        }
      }
    },
    onFileSelected(file, element = null) {
      const fileObject = {
        link: null,
        extension: getFileExtension(file.name),
        type: file.type,
        name: file.name,
        size: file.size / 1000,
        created: file.lastModified,
        modified: file.lastModified,
        readOnly: true,
      };

      this.selectedElementID = this.selectedElement
        ? this.selectedElement.id
        : element.id;

      if (this.selectedElement && this.selectedElement.type === `filenew`) {
        this.$refs[
          `formElements${this.selectedElement.id}`
        ][0].onFileSelectedFromElementProps(fileObject);
      }
      this.mutableElements.forEach((mutableElement) => {
        if (mutableElement.type === 'togglelist' && mutableElement.elements) {
          mutableElement.elements.forEach((el) => {
            if (el.id === this.selectedElementID) {
              el.value = fileObject;
              el.files = file;
            }
          });
        } else if (mutableElement.id === this.selectedElementID) {
          mutableElement.value = fileObject;
          mutableElement.files = file;
        }
      });
    },
    onFileDelete(element = null) {
      this.selectedElementID = this.selectedElement
        ? this.selectedElement.id
        : element.id;
      if (this.$refs[`formElements${this.selectedElementID}`]) {
        this.$refs[`formElements${this.selectedElementID}`][0].onFileDelete(
          element,
          false
        );
      }
      this.mutableElements.forEach((mutableElement) => {
        if (mutableElement.type === 'togglelist' && mutableElement.elements) {
          mutableElement.elements.forEach((el) => {
            if (el.id === this.selectedElementID) {
              el.value = null;
              el.files = null;
            }
          });
        } else if (mutableElement.id === this.selectedElementID) {
          mutableElement.value = null;
          mutableElement.files = null;
        }
      });
    },
    closeAddDropDown() {
      this.isAddElementVisible = false;
    },
    isKeyNotInElementObject(element, key) {
      (element.type === 'radio' || element.type === 'checkbox') &&
        element.attributes.appearance === 'card' &&
        !(key in element.attributes);
    },
    toggleErrorInForm(newValue) {
      this.isErrorInForm = newValue;
    },
    updateMutableElements() {
      if (this.isEditable) {
        this.elements.forEach((element) => {
          if (this.isKeyNotInElementObject(element, 'isImgShowInBackGround')) {
            element.attributes['isImgShowInBackGround'] = false;
          }
          if (
            this.isKeyNotInElementObject(element, 'isShowTitleAndDescription')
          ) {
            element.attributes['isShowTitleAndDescription'] = false;
          }
        });
        this.mutableElements = structuredClone(this.elements);
      } else {
        let isNestedStart = false;
        this.mutableElements = structuredClone(this.elements)?.reduce(
          (acc, cur) => {
            if (
              ['togglelist', 'wrapper'].includes(cur.type) &&
              cur.name.includes('start')
            ) {
              isNestedStart = true;
              acc.push({ ...cur, elements: [] });
            } else if (isNestedStart) {
              acc[acc.length - 1].elements.push(cur);
              if (
                ['togglelist', 'wrapper'].includes(cur.type) &&
                cur.name.includes('end')
              )
                isNestedStart = false;
            } else {
              acc.push(cur);
            }
            return acc;
          },
          []
        );
      }

      this.mutableStructure = structuredClone(this.structure);
    },
    isElementHasSettings(element) {
      return element.hasOwnProperty('settings');
    },

    getElementSettings(element, key) {
      if (this.isElementHasSettings(element)) {
        return element.settings.hasOwnProperty(key)
          ? element.settings[key]
          : null;
      } else {
        return element.hasOwnProperty(key) ? element[key] : null;
      }
    },
    checkSelectDropdownValidation() {
      if (this.isAddingNewItem) {
        let isValidDropdown = true;
        const selectElements = this.mutableElements.filter(
          (element) => element.type == 'select'
        );
        if (selectElements.length) {
          selectElements.forEach((element) => {
            if (element.attributes.required && !element.value) {
              this.showToaster(
                `${element.label} ist ein Pflichtfeld`,
                'Fehlerhaft !',
                'danger'
              );
              isValidDropdown = false;
            }
          });
        }
        if (!isValidDropdown) return false;
      }
      return true;
    },
    onElementMoreIconClick() {
      this.isAddElementVisible = false;
    },
    insertNewElement(idx, type) {
      this.isNewFormElement.idx = idx;
      this.isNewFormElement.type = type;
      this.toggleAddDropDown();
    },
    showScrollbar(event) {
      event.target.classList.add('show-scrollbar');
      debouncer(
        () => {
          event.target.classList.remove('show-scrollbar');
        },
        300,
        this,
        'removeScrollClass'
      );
    },
    onDatabaseLinkedViewScroll(e) {
      const databaseLinkedViewElem = this.elements.findIndex(
        (elem) => elem.type === 'databaselinkedview'
      );
      if (databaseLinkedViewElem !== -1) {
        this.$refs[
          `formElements${this.elements[databaseLinkedViewElem].id}`
        ][0]?.$refs?.customDatabaseInline?.$refs?.customDatabaseListRef?.$refs?.customTableRef?.onDatabaseLinkedViewScroll();
      } else {
        this.showScrollbar(e);
      }
    },

    addUiInUiElement(uiResponse) {
      this.$emit('addUiInUiElement', uiResponse);
    },

    setChatGptApiLoader(loaderState) {
      this.isChatGptApiLoader = loaderState;
    },
    checkRangeSelectionValidtion(element) {
      const min = element.attributes.min && Number(element.attributes.min);
      const max = element.attributes.max && Number(element.attributes.max);
      const step = element.attributes?.step && Number(element.attributes.step);
      return (
        min !== '' &&
        max !== '' &&
        max > min &&
        ((step && step >= 0) || !step) &&
        this.isValidSelectedElementName()
      );
    },
    onFileChange(element) {
      if (element.type === 'file') {
        const dataTransfer = new DataTransfer();
        if (element?.files?.length) {
          dataTransfer.items.add(element?.files[0]);
        }
        const fileElement = document.getElementById(`input-${element.id}`);
        fileElement.files = dataTransfer.files;
        this.isAddButtonDisabled = !this.formValidation();
      }
    },

    setFileInputs() {
      const fileElements = this.elements.filter(
        (element) => element.type == 'file'
      );

      fileElements.forEach((element) => {
        this.onFileChange(element);
      });
    },
    setDatabaseLinkedViewCols() {
      if (this.isPropsModalVisible) {
        this.$refs.propsModal.setDatabaseLinkedViewCols();
      }
    },
    updatePropsModalValidationState() {
      this.isAddButtonDisabled = !this.formValidation(false);
    },
    onElementInputBlur(elementName) {
      this.$nextTick(() => {
        this.refreshDatabaseLinkedViewsForSource(elementName);
      });
    },
    refreshDatabaseLinkedViewsForSource(elementName) {
      Object.keys(this.$refs)
        .filter((refName) => refName.startsWith('formElements'))
        .flatMap((refName) => this.$refs[refName])
        .forEach((formElementRef) => {
          formElementRef?.refreshDatabaseLinkedViewsForSource?.(elementName);
        });
    },
    toggleAiDropdown(toggleId) {
      this.$emit('toggleAiDropdown', toggleId);
    },
    handleCloseAiPopup(event) {
      if (this.isChatGptApiLoader) {
        event.preventDefault();
      } else {
        this.$refs.customdbFrom.classList.remove('ai-target-element');
        this.$emit('toggleAiDropdown', 'formStyle');
      }
    },
    handleShowAiPopup() {
      this.$emit('toggleAiDropdown', 'formStyle');
    },
    onGenerateAutomatedCSSKeydown(event) {
      if (event.code === 'Enter' && !this.isChatGptApiLoader) {
        this.generateAutomatedAICSS();
        event.preventDefault();
      }
    },
    async generateAutomatedAICSS() {
      try {
        if (this.isChatGptApiLoader) return;
        this.isChatGptApiLoader = true;
        this.chatGptApiError = '';
        const automatedaicssElement = this.elements.find(
          (element) => element.type === 'automatedaicss'
        );
        const errorMessage =
          'Please ask style-related questions for available elements';
        if (!this.chatGptApiInput) return;

        const url = this.flowRunnerEndpoint;

        const prompt = `As a CSS code generator assistant, you must adhere to given conditions and provide no extra responses. First, you will read the provided question and provide css for the given elementId codelosForm. you will Respond with only the css code with #codelosForm prefix (because all element wrapper in form with id is codelosForm) for requested element without explanation. Otherwise, if you didn't get anything or not able to understand or question is not regarding css then respond with the message "${errorMessage}" wihtout including anything in this string no extra response needed.
 here is my current css code: "${
   automatedaicssElement
     ? automatedaicssElement.value.replace(
         /<style[^>]*>([\s\S]*?)<\/style>/gi,
         '$1'
       )
     : ''
 }", use the current provided styles and return whole code as updated (only update the style of given element id, please don't update other elements except the provided element id and return the whole code) without a single extra word or character or symbols or backticks at starting and ending.
        question:"${this.chatGptApiInput}".`;

        let responseMessage;
        if (getApiEndpointVersion(url) >= 6) {
          const formData = new FormData();
          formData.append(
            'props',
            JSON.stringify({
              prompt,
              model: 'gpt-4',
            })
          );
          const response = await askChatGPT(url, formData);
          responseMessage = response.data.message;
        } else {
          const response = await askChatGPT(url, {
            prompt,
          });
          responseMessage = response.data.message;
        }
        let sanitizedMessage = responseMessage;
        const patternToRemoveFromResponse =
          /^```(?:css)?([\s\S]*?)```$|^"([\s\S]*)"$/;
        if (patternToRemoveFromResponse.test(responseMessage)) {
          sanitizedMessage = responseMessage.replace(
            patternToRemoveFromResponse,
            '$1$2'
          );
        }

        if (!sanitizedMessage.startsWith('Please')) {
          this.addUiInUiElement(sanitizedMessage);
          this.chatGptApiInput = '';
        } else {
          throw new Error(sanitizedMessage);
        }
      } catch (error) {
        this.chatGptApiError = error.message.startsWith('Please')
          ? error.message
          : 'CSS kann nicht generiert werden';
      } finally {
        this.isChatGptApiLoader = false;
      }
    },
    onClickForm(event) {
      if (this.isAskAiUiModalVisible && !this.isChatGptApiLoader) {
        this.chatGptApiInput = '';
        this.chatGptApiError = null;
        if (this.$refs.chatGptDropDown.visible) {
          this.targetedElementId = null;
          this.$refs.chatGptDropDown.hide();
        } else {
          if (!event.target.closest('.form-builder-element-attributes')) {
            this.$refs.chatGptDropDown.show();
            this.$refs.customdbFrom.classList.add('ai-target-element');
            setTimeout(() => {
              const dropdown = this.$refs.chatGptDropDown?.$el;
              if (dropdown) {
                dropdown.style.top = `${event.pageY}px`;
              }
              this.$nextTick(() => {
                this.$refs.chatgptInputRef &&
                  this.$refs.chatgptInputRef.focus();
              });
            });
          }
        }
      }
    },
    addElementAfterConfirm() {
      if (
        this.renameConfirmModalData.elementName &&
        this.renameConfirmModalData.defaultElement
      ) {
        this.addElement(
          this.renameConfirmModalData.defaultElement,
          this.renameConfirmModalData.elementName
        );
        this.renameConfirmModalData.elementName = null;
        this.renameConfirmModalData.defaultElement = null;
      }
    },
    removeElementAfterCancle() {
      this.renameConfirmModalData.elementName = null;
      this.renameConfirmModalData.defaultElement = null;
    },
    getId(id) {
      return this.isSideBarLinkItem ? `${id}-${this.isSideBarLinkItem}` : id;
    },
    isObjectListInEditMode() {
      let isObjectListInEditMode = false;
      const objectLists = this.elements.filter((el) => el.type == 'objectlist');

      for (let index = 0; index < objectLists.length; index++) {
        const element = objectLists[index];
        const ref = this.$refs[`formElements${element.id}`];
        if (ref.length > 0 && ref[0].getIsCardInEditMode) {
          isObjectListInEditMode = ref[0].getIsCardInEditMode();
          if (isObjectListInEditMode) {
            break;
          }
        }
      }

      return isObjectListInEditMode;
    },
  },
  updated() {
    if (
      this.isCalledInElementsProps &&
      JSON.stringify(this.elements) !== JSON.stringify(this.mutableElements)
    ) {
      this.updateMutableElements();
      this.addMissingAttributes();
    }
    this.$nextTick(() => {
      this.checkTokenRefresh();
    });
  },
  created() {
    // Add class to make background fixed
    document.body.classList.add('modal-open');
    this.updateMutableElements();
    this.addMissingAttributes();
  },
  destroyed() {
    // remove class that makes background fixed
    document.body.classList.remove('modal-open');
  },
  watch: {
    mutableElements() {
      this.$emit('saveElements', this.mutableElements);
    },
    mutableStructure() {
      this.$emit('saveStructure', this.mutableStructure);
    },
    isPropsModalVisible(newVal, oldVal) {
      if (this.isCalledInElementsProps) {
        this.$emit('objectListModalWatch', newVal);
      }
    },
    selectedElement: {
      handler() {
        this.isAddButtonDisabled = !this.formValidation(false);
      },
      deep: true,
    },
  },
  computed: {
    getMutableElements() {
      if (this.databaseMeta && this.databaseMeta.sql_cdls) {
        const sqlCdls = JSON.parse(this.databaseMeta.sql_cdls);

        return this.mutableElements.filter(
          (element) =>
            !Object.values(sqlCdls).find((key) => key === element.name)
        );
      } else return this.mutableElements;
    },
    filteredMutableElements() {
      if (this.search) {
        return structuredClone(this.getMutableElements)?.reduce((acc, cur) => {
          if (cur.label.toLowerCase().includes(this.search.toLowerCase())) {
            if (
              cur.type == 'togglelist' &&
              cur.name.includes('start') &&
              cur.elements?.length
            ) {
              cur.elements = cur.elements.filter((element) =>
                element.label.toLowerCase().includes(this.search.toLowerCase())
              );
            }
            acc.push(cur);
          }
          return acc;
        }, []);
      } else {
        return this.getMutableElements;
      }
    },
    existingNames() {
      return [
        ...this.elementInputsProp,
        ...this.elements,
        ...this.getAllFormElements,
      ].map((e) => e.name);
    },
    existingLabels() {
      return [
        ...this.elementInputsProp,
        ...this.elements,
        ...this.getAllFormElements,
      ].map((e) => e.label);
    },
    user() {
      return this.$store.state.user;
    },
    isAdmin() {
      return this.$store.state.isAdmin;
    },
    paramString() {
      let paramString = '';

      this.elements.forEach((e) => {
        if (e.type != 'html') paramString += e.name + '=' + e.value + '&';
      });
      return paramString.slice(0, -1);
    },
    selectableTypes() {
      let tempTypeList;
      if (this.elementsToHide && this.elementsToHide.length > 0) {
        tempTypeList = [...this.typeList].filter(
          (el) => !this.elementsToHide.includes(el.name.trim())
        );
      } else {
        tempTypeList = this.typeList;
      }
      tempTypeList = tempTypeList.filter(
        (el) =>
          !el.isInternalUseOnly &&
          (this.formulaVersion >= 8 || el.name !== 'resultwindow')
      );
      if (!this.isUserHasAccess) {
        tempTypeList = tempTypeList.filter((e) =>
          e.element
            ? this.getElementSettings(e.element, 'layoutItem')
            : this.getElementSettings(e, 'layoutItem')
        );
      }
      if (
        !this.isCreateCustomDB ||
        (this.isCreateCustomDB && this.isFreeContentAlreadyExist)
      ) {
        tempTypeList = tempTypeList.filter((el) => el.name !== 'freecontent');
      }
      if (!this.isDatabaseContext) {
        tempTypeList = tempTypeList.filter(
          (el) => !['databaselinkedview', 'status'].includes(el.name)
        );
      }
      tempTypeList = tempTypeList.filter((el) =>
        el.caption
          ?.toLowerCase()
          ?.includes(this.searchFormElement?.trim()?.toLowerCase())
      );
      if (this.elsToShow)
        return tempTypeList.filter((e) => this.elsToShow.includes(e.name));
      if (this.isAdmin)
        return tempTypeList.filter((e) => e.visibility != 'hidden');
      return tempTypeList.filter(
        (e) => e.visibility != 'hidden' && e.visibility != 'admin'
      );
    },
    activeTab() {
      return 0;
    },
    isDatabaseContext() {
      return (
        this.isCreateCustomDB ||
        Boolean(this.selectedDatabase) ||
        Boolean(this.databaseMeta)
      );
    },
    isFreeContentAlreadyExist() {
      return this.elements.find((element) => element.type === 'freecontent');
    },

    isFullWidthForm() {
      return this.isFullWidth || this.isAddingNewItem;
    },
    elementInputsProp() {
      return this.elementInputs ? this.elementInputs : [];
    },
    getAllFormElements() {
      return this.process?.tasks?.length
        ? this.process?.tasks?.flatMap((task) =>
            ['Start', 'Form'].includes(task.name) && task.id !== this.task?.id
              ? task?.props?.formTrigger?.elements || []
              : []
          )
        : [];
    },
    getFormattedDate() {
      if (this.createdValue) {
        const date = moment(this.createdValue).format(
          !this.databaseMeta.hasOwnProperty('showSeconds') ||
            this.databaseMeta.showSeconds === null ||
            JSON.parse(this.databaseMeta.showSeconds)
            ? 'DD.MM.YYYY HH:mm:ss'
            : 'DD.MM.YYYY HH:mm'
        );
        return date ? date : '--';
      }
      return '';
    },
    checkUserNameChanged() {
      return this.$refs?.propsModal?.checkUserNameChanged();
    },
    showCreatedField() {
      let show = true;
      if (
        this.search &&
        !'Erstellt am'.toLowerCase().includes(this.search.toLowerCase()) &&
        !String(this.getFormattedDate).includes(this.search)
      ) {
        show = false;
      }
      return show && this.createdValue && !this.isCopyDatabaseItem;
    },
    showIdField() {
      let show = true;
      if (
        this.search &&
        !'ID'.toLowerCase().includes(this.search.toLowerCase()) &&
        !String(this.idValue).includes(this.search)
      ) {
        show = false;
      }
      return (
        show &&
        this.idValue !== null &&
        this.idValue !== undefined &&
        this.idValue !== '' &&
        !this.isCopyDatabaseItem
      );
    },
  },
  mounted() {
    const formScrollComponent = document.getElementsByClassName('form-tab');
    if (formScrollComponent.length !== 0) {
      formScrollComponent[0].addEventListener('wheel', this.closeAiInputModal);
    }

    this.setFileInputs();
  },
  beforeDestroy() {
    const formScrollComponent = document.getElementsByClassName('form-tab');
    if (formScrollComponent.length !== 0) {
      formScrollComponent[0].removeEventListener(
        'wheel',
        this.closeAiInputModal
      );
    }
  },
  components: {
    elementProps: () => import('../modals/elementProps.vue'),
    LoadingSpinner,
    ElementRenderer,
    PlusIconButton,
    CommonSwitch,
  },
  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        el.eventSetDrag = function () {
          el.setAttribute('data-dragging', 'yes');
        };
        el.eventClearDrag = function () {
          el.removeAttribute('data-dragging');
        };
        el.eventOnClick = function (event) {
          var dragging = el.getAttribute('data-dragging');
          // Check that the click was outside the el and its children, and wasn't a drag
          if (!(el == event.target || el.contains(event.target)) && !dragging) {
            // call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener('touchstart', el.eventClearDrag);
        document.addEventListener('touchmove', el.eventSetDrag);
        document.addEventListener('click', el.eventOnClick);
        document.addEventListener('touchend', el.eventOnClick);
      },
      unbind(el) {
        document.removeEventListener('touchstart', el.eventClearDrag);
        document.removeEventListener('touchmove', el.eventSetDrag);
        document.removeEventListener('click', el.eventOnClick);
        document.removeEventListener('touchend', el.eventOnClick);
        el.removeAttribute('data-dragging');
      },
    },
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  position: fixed;
  background: #ffffff;
  height: 98%;
  border-radius: 4px;
  display: block;
  width: 70%;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  top: 0;
  left: 15%;
  top: 1%;
}

.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}

h1 {
  padding-top: 46px;
  padding-bottom: 8px;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 4px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}

h4 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

.tab {
  text-align: left;
  background: #f9f9fb;
  padding: 20px 16px;
  padding-top: 0px;
}

.tab.tab-form {
  background-color: #fff;
}

.tab.tab-time {
  height: 350px;
}

.date {
  margin-top: 0;
  width: 53%;
}

.time {
  width: 33%;
}

button.default {
  color: #464d5d;
  background: #fff;
}

.input-group {
  display: inline-block;
  width: 100%;
}

.imput-group > input {
  width: 40%;
  margin: 0px 20px 20px 0px;
}

.input-group > button {
  min-width: 0;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  color: #fff;
  background: #6bbc7c;
  border: 1px solid #5ab36c;
  margin-bottom: 0;
  border-radius: 0 3px 3px 0;
}

.pull-right {
  float: right;
  height: 50px;
  overflow: hidden;
}

button.pull-right {
  margin-right: 0px;
}

.btn-close.pull-right {
  margin-right: 15px;
  margin-top: 15px;
  height: 10px;
}
.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}

ul.tabsLabels {
  display: inline-block;
  padding: 0;
  margin: 0 0 -1px;
}

.modal ul.tabsLabels li {
  display: inline-block;
  margin-right: 44px;
  list-style: none;
  padding: 0;
  line-height: 14px;
}

.modal:not(.custom) li {
  font-size: 14px;
  line-height: 25px;
  color: #7e8890;
}

.modal ul.tabsLabels a {
  color: #a4abb1;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  padding: 21px 7px 22px 33px;
  border-bottom: 2px solid transparent;
  display: block;
  position: relative;
}

.modal ul.tabsLabels a.datetime {
  padding: 21px 7px 22px 0px;
}

.modal ul.tabsLabels a.active {
  border-color: #52b266;
}

.modal ul.tabsLabels a.active,
.modal ul.tabsLabels a:hover {
  color: #464d5d;
  text-decoration: none;
}

/*@media not all, not all, (-webkit-min-device-pixel-ratio: 1.5), not all, (min-resolution: 1.5dppx)*/
.tabsLabels .email {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -1100px -1110px;
}

.tabsLabels .form {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -893px -1110px;
}

.tabsLabels .alert {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -546px -1110px;
}

.systems {
  background-color: #f9f9fb;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: auto;
  width: 100%;
}

.item-wrapper {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  border-radius: 4px;
  background: #fff;
  height: 150px;
  text-align: center;
  margin: 0 39px 43px 0;
  -webkit-box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.item-wrapper h2 {
  color: #424956;
  font-size: 12px;
  font-weight: 400;
  line-height: inherit;
  margin-top: 0px;
}

.systems-wrapper {
  width: 100%;
  margin: 24px 31px;
}

.img-wrapper {
  width: 100%;
  height: 111px;
}

.systems .logo {
  position: absolute;
  width: 70%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.icon {
  width: 30px;
  float: left;
  margin-right: 10px;
  margin-top: 6px;
}

.icon svg {
  fill: #959ba8;
}

.btn-default {
  background-color: #fff;
  color: #959ba8;
  text-align: center;
  border-color: rgb(214, 214, 221);
  line-height: 50px;
  cursor: pointer;
}

.tab.tab-form button {
  width: fit-content;
  padding-right: 19px;
  float: right;
  margin: 0 0 0 5px;
}

.tab.tab-form button.btn-green {
  padding-left: 20px;
}

.params {
  float: left;
  width: 30%;
}

.params > h2 {
  padding-top: 0;
  padding-bottom: 15px;
  margin-right: 10px;
  margin-bottom: 0px;
  color: #797c81;
  font-weight: 400;
  line-height: 19px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 16px;
  text-transform: uppercase;
  text-align: left;
}

.modal.task .header {
  width: 100%;
}

.modal.task .header .tools {
  float: right;
  height: 70px;
  width: auto;
  flex-direction: row;
  margin-top: 5px;
}

.modal.task .header .tools .item {
  display: inline-block;
  text-align: center;
  line-height: 61px;
  margin-left: 10px;
}

.form-container {
  background: #fff;
  width: 100%;
}

.form-header {
  display: block;
  height: 100px;
}

.form-settings {
  float: right;
  padding-right: 25px;
}

.form-settings i {
  font-size: 30px;
  padding-left: 15px;
  cursor: pointer;
}

.form-container input.title {
  z-index: 4;
  text-align: center;
  display: block;
  padding-bottom: 8px;
  font-size: 33px;
  color: #464d5d;
  margin: 5px 5px 5px 7px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  border: 0;
  height: 50px;
  float: left;
  width: 99%;
}

.form-container input.description {
  z-index: 4;
  text-align: center;
  border: 0;
  display: block;
  float: left;
  margin: 5px 5px 15px 7px;
  width: 99%;
  color: #888d9c;
}

.form-input {
  cursor: text;
}

.form-input.highlighted {
  background: #ff000024;
  padding: 5px;
}

.add-button-wrapper {
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
}

.create-custom-db-wrapper .add-button-wrapper {
  width: fit-content;
  margin: 30px auto 20px;
}

.add-button {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background-color: #191f25;
  padding: 5px;
  border-radius: 50%;
  font-size: 40px;
  transition: transform 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
  height: 60px;
  width: 60px;
  line-height: 1;
}

.add-button:hover {
  transform: scale(1.1);
}

.modal.task .header .tools .item:hover {
  transform: scale(1.1) rotate(0);
}

.input-group > button {
  min-width: 0;
  width: 99px;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  background: #fff;
  margin-bottom: 0;
  margin-left: 0;
  border-radius: 0 3px 3px 0;
  margin-top: 0;
  font-size: 35px;
  font-weight: 200;
}

.input-group > select {
  margin-right: 0;
  border-radius: 0 3px 3px 0;
}

.form-container form.codelos-app {
  /* width: 800px; */
  width: 80%; /* For New form elements */
  text-align: left;
  min-height: 207px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.form-container form.codelos-app .form-tab .row {
  justify-content: center;
}
.form-container form.codelos-app.full-width {
  width: 100%;
}
.form-container form.ai-cursor-active ::v-deep * {
  cursor: url('../../assets/img/work-flow-icons/magic-stick.svg') 16 16, auto;
}
form .form-group {
  width: 100%;
  min-height: 35px;
  height: fit-content;
  margin-top: 0px;
  position: relative;
}

.form-group.large {
  height: 160px;
}
.round-button {
  cursor: pointer;
  display: block;
  color: #1d1d1f;
  border-radius: 50%;
  background-color: white;
  height: 60px;
  width: 60px;
  text-align: center;
  line-height: 60px;
  font-weight: 100;
  box-shadow: 0.5px 0.87px 5px 0 rgba(0, 0, 0, 0.28);
  transition: transform 0.2s ease-in-out;
  font-size: 17px;
}

.footer {
  position: fixed;
  bottom: 21px;
}
.message {
  position: absolute;
  color: #54c08a;
  font-size: 16px;
  margin: 0;
  margin-top: 3px;
}

.loading {
  width: 100%;
  height: 100%;
  background-color: #ffff;
  position: relative;
  top: -100%;
  z-index: 3;
}

.loading.transparent {
  background-color: #9191912e;
}

.progress-icon-wrapper {
  top: 0;
  bottom: 67px;
  height: fit-content;
  width: fit-content;
  left: 0;
  right: 0;
  margin: auto;
  position: absolute;
}

.progress-icon {
  width: 76px;
  height: 76px;
  margin-left: auto;
  top: 0;
  left: 0;
  margin-right: auto;
  margin-top: 28px;
}

.progress-icon:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #313745;
  border-color: #313745 transparent #313745 transparent;
  animation: progress-icon 1.2s linear infinite;
}

.file-key-selector {
  position: absolute;
  top: 25%;
  left: 40%;
  background: white;
  z-index: 10;
  width: 200px;
  height: 300px;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.drop-down {
  font-size: 14px;
  color: #4a556a;
  font-family: sans-serif;
  -webkit-font-smoothing: unset;
  padding: 11px;
  border-radius: 9px;
  box-shadow: 0 2px 8px rgb(31 37 50 / 18%);
  position: absolute;
  z-index: 100;
  width: 270px;
  list-style: none;
  background-color: #fff;
  overflow: hidden;
  /* max-height: calc(100vh - 260px); */
  border: none;
  left: 22%;
  right: 100%;
}

.start-form-builder .drop-down {
  left: 32%;
}

.drop-down.add-element img {
  background-color: #fefbfb;
  vertical-align: middle;
  border-style: none;
  width: 78px;
  height: 78px;
  padding: 13px;
  margin: 4px;
  border-radius: 5px;
  border: 1px solid #d2d0d0;
}

.drop-down.add-element .item {
  padding: 5px;
  border-radius: 5px;
  width: 100%;
  cursor: pointer;
  transition: background 0.3s ease-in-out;
}

.drop-down.add-element .item:hover {
  background: #f1efef;
}
/* .form-container .add-element-wrapper::-webkit-scrollbar {
  display: none;
} */

/* .col {
  max-width: 89%;
} */

.showResultInForm {
  background-color: #cccccc;
}

.workflow-model-scroll .modal.task,
.workflow-model-scroll .modal.task .form-container {
  overflow: unset !important;
}
.workflow-model-scroll .modal.task .form-tab {
  max-height: calc(100vh - 415px);
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 150px;
}

.drop-down.add-element * {
  box-sizing: border-box;
}

.form-container .add-button-wrapper .add-element .item.item-disabled {
  background: #e3e3e3fc !important;
  color: #a3a3a3;
  cursor: not-allowed;
  opacity: 0.6;
}

.form-container .add-button-wrapper .add-element .item.item-disabled img {
  background: #e3e3e3fc !important;
  color: #a3a3a3;
}

::v-deep .toast .toast-header button.close {
  margin-left: auto;
  margin-bottom: 0;
  font-size: 1.3rem;
  line-height: 0;
  color: #000;
  opacity: 0.5;
  border: none;
  background: transparent;
}
::v-deep .toast:not(.show) {
  display: block;
}
.form-container .form-element-search-wrapper {
  border: 1px solid #97979e;
  margin-left: 8px;
  padding: 2px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  height: 36px;
  gap: 4px;
}
.form-container .form-element-search-wrapper input {
  width: 100%;
  outline: none;
  font-size: 14px;
  color: #4a556a;
}

.form-container .form-element-search-wrapper .search-icon {
  border: none !important;
  background: transparent !important;
  width: 24px !important;
  padding: 0 !important;
  margin: 0 !important;
  margin-left: 4px !important;
  height: 24px !important;
}

.form-container .add-element-wrapper {
  overflow: auto;
  max-height: calc(100vh - 340px);
  margin-block: 8px;
}
.form-container .img-wrapper-div {
  display: flex;
  align-items: center;
  gap: 5px;
}
.form-container .field-search-wrapper {
  width: 47%;
  position: relative;
  margin: 10px auto;
  padding-right: 10px;
  padding-left: 3px;
}

.form-container .field-search-wrapper ::v-deep * {
  cursor: auto !important;
}
.form-container .field-search-wrapper.create-custom-db {
  width: 58%;
  padding-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.form-container ::v-deep .pagination-switch .toggle-switch {
  vertical-align: middle;
}
.form-container .field-search-wrapper .search-text {
  width: 100%;
  padding: 11px 9px 11px 32px;
  height: auto;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.18px;
  -webkit-box-shadow: none;
  box-shadow: none;
  background: #fff;
}
.form-container .field-search-wrapper .search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
}
.form-container .created-wrapper div {
  margin: auto;
  max-width: 75%;
  padding: 12px;
}
.form-container .created-wrapper .created-label {
  margin: 0 0 6px;
  width: 100%;
  font-weight: 300;
  font-family: 'Open Sans', open-sans, sans-serif;
  display: block;
  color: #464d5d;
  font-size: 14px;
}

.form-container .created-wrapper .created-input {
  margin: 0 0 0;
  width: 100%;
  padding: 8px 12px;
  height: auto;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 13px;
  font-weight: 400;
  line-height: 19px;
  -webkit-box-shadow: none;
  box-shadow: none;
  background: #fff;
  cursor: auto;
}

::v-deep .form-builder-element-attributes-label {
  position: absolute;
  margin: 0 !important;
  z-index: 100000;
}
.form-builder-element-attributes-label ::v-deep .dropdown-toggle {
  background: transparent;
  color: #464d5d;
  border: none;
  text-align: left;
  padding: 0;
  font-size: 14px;
}
.form-builder-element-attributes-label ::v-deep .dropdown-menu {
  left: 10px !important;
  min-width: 310px;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.2);
  border: none;
  padding: 15px;
}

.form-builder-element-attributes-label ::v-deep .dropdown-toggle::after {
  content: none;
}
.ai-dropdown-wrap .custom-table-progress-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  border-color: #ffffff transparent #ffffff transparent;
  animation: progress-icon-animation 1.2s linear infinite;
  margin: 0 auto;
}
@keyframes progress-icon-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.ai-dropdown-wrap input[type='text'] {
  margin: 0;
  padding: 0;
  border: none;
  width: 100%;
  padding: 10px;
}

.ai-dropdown-wrap input[type='text']::placeholder {
  opacity: 0.7;
  font-size: 14px;
}

.ai-dropdown-wrap .submit-btn {
  width: auto;
  padding: 9px 20px !important;
  height: auto;
  min-width: 100px;
  margin: 20px 0 0 0;
  float: right;
  transform: translateY(0) scale(1.001);
  background-color: #000;
  display: inline-block;
  font-family: proxima-nova, Helvetica Neue, Arial, sans-serif;
  font-weight: 700;
  line-height: 23px;
  padding: 0.5rem 1.5rem;
  white-space: pre;
  font-size: 0.9375rem;
  color: #fff;
  border: 3px solid #000;
  border-radius: 0.375em;
  text-transform: none;
}

.ai-dropdown-wrap .error {
  color: red;
  font-size: 12px;
  margin-top: 10px;
  display: inline-block;
}

.inner-scroll .form-container .ai-cursor-active.ai-target-element,
.inner-scroll .form-container .ai-cursor-active.highlight-border {
  outline: 2px solid #ff3366 !important;
  outline-offset: 0px !important;
}
</style>
